import { useMutation } from "@apollo/client";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { AiIntegrationView } from "../../useSearchAiIntegrations/gql";
import AiIntegrationDeleteConfirmationContent from "./Content";
import { DELETE_AI_INTEGRATION } from "./gql";

type AiIntegrationDeleteConfirmationProps = {
  integration: AiIntegrationView;
  refetchQueriesOnDelete?: string[];
  onDeleteSuccess?: () => void;
};

const AiIntegrationDeleteConfirmation = create(function DeleteConfirmation({
  integration,
  refetchQueriesOnDelete,
  onDeleteSuccess,
}: AiIntegrationDeleteConfirmationProps) {
  const modal = useModal();

  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [deleteIntegration, { loading }] = useMutation(DELETE_AI_INTEGRATION, {
    awaitRefetchQueries: true,
    refetchQueries: refetchQueriesOnDelete,
  });

  const onConfirm = () => {
    deleteIntegration({ variables: { id: integration.id } })
      .then((data) => {
        if (data?.data?.aiIntegrationDelete?.id) {
          reportSuccess({ message: "Integration successfully removed" });
          modal.hide();
          onDeleteSuccess?.();
        }
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete integration"
      onConfirm={onConfirm}
      isLoading={loading}
      isDismissable={!loading}
    >
      <AiIntegrationDeleteConfirmationContent integration={integration} />
    </DeleteConfirmationModal>
  );
});

export const showAiIntegrationDeleteConfirmation = (props: AiIntegrationDeleteConfirmationProps) =>
  show(AiIntegrationDeleteConfirmation, props);
